/**
 * Shared source-domain URL matching used by brand skinning and pre-publish audit.
 */

export const LOGO_SENTINEL_VALUE = '__PB_LOGO_PLACEHOLDER_a3f7b2__';

function clean(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeUrlForMatch(value, sourceDomain) {
  const src = clean(value);
  if (!src) return '';
  try {
    return new URL(src, sourceDomain ? `https://${sourceDomain}` : undefined).href;
  } catch {
    return src;
  }
}

export function isSourceDomainUrl(value, sourceDomain) {
  if (value === LOGO_SENTINEL_VALUE || String(value || '').startsWith('data:')) return false;
  const normalized = normalizeUrlForMatch(value, sourceDomain);
  if (!normalized || !sourceDomain) return false;
  try {
    const host = new URL(normalized).hostname.replace(/^www\./, '');
    return host === String(sourceDomain).replace(/^www\./, '');
  } catch {
    return false;
  }
}
